import { Box, Button, SxProps, Theme, Typography } from "@mui/material";
import CustomIcon from "components/CustomIcon";

import { useIntl } from "react-intl";
import icons from "enums/icons";

interface Props {
    onClick: () => void;
    title: string;
    icon: JSX.Element;
    backgroundColor: string;
    buttonLabel: string;
    color?: string;
    sx?: {
        title?: SxProps<Theme> | undefined;
        button?: SxProps<Theme> | undefined;
    };
}

const LeadershipSnapshotCard = ({ onClick, title, icon, backgroundColor, buttonLabel, color, sx }: Props) => {
    const intl = useIntl();

    return (
        <>
            <Box
                sx={(theme: Theme) => ({
                    borderRadius: "8px",
                    backgroundColor: backgroundColor,
                    padding: theme.spacing(2),
                    marginRight: theme.spacing(2),
                    display: "flex",
                    flexDirection: "column",
                    flex: 1,
                    color: color,
                })}
            >
                <Box display="flex" alignItems="center" justifyContent="center" mb={2} sx={{ ...sx?.title }}>
                    {icon}
                    <Typography variant="subtitle1">{intl.formatMessage({ id: title })}</Typography>
                </Box>
                <Button
                    variant="outlined"
                    sx={{ marginBottom: "8px", ...sx?.button }}
                    endIcon={<CustomIcon icon={icons.arrowRight} />}
                    onClick={onClick}
                >
                    {buttonLabel}
                </Button>
            </Box>
        </>
    );
};

export default LeadershipSnapshotCard;
